import { Component, ErrorInfo, ReactNode } from "react";
import { useSelector } from "react-redux";
import SessionExpiredConsent from "../components/session-expired-consent";
import SessionHardCapExpired from "../components/session-hard-cap-expired";
import { ReduxState } from "../reducers";
import SideNav from "./SideNav";
import "./styles.css";
import TopBar from "./TopBar";
interface ComponentProps {
  children: ReactNode;
}

class LayoutErrorBoundary extends Component<
  ComponentProps,
  {
    hasError: boolean;
  }
> {
  state: {
    hasError: boolean;
  } = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Layout child render error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="layout-error-boundary" role="alert">
          <h1>Something went wrong</h1>
          <p>Please refresh the page or try again later.</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default function Layout({ children }: ComponentProps) {
  const consentVisible = useSelector(
    (state: ReduxState) => state.session.consentVisible,
  );
  const hardCapExpired = useSelector(
    (state: ReduxState) => state.session.hardCapExpired,
  );

  if (hardCapExpired) {
    return <SessionHardCapExpired />;
  }

  return (
    <div className="page-wrapper">
      <SideNav />
      <div className="content">
        <TopBar />
        <main>
          <LayoutErrorBoundary>{children}</LayoutErrorBoundary>
        </main>
      </div>
      {consentVisible && <SessionExpiredConsent />}
    </div>
  );
}
